import { render, staticRenderFns } from "./OrderWithoutItem.vue?vue&type=template&id=6280328e&scoped=true"
import script from "./OrderWithoutItem.vue?vue&type=script&lang=js"
export * from "./OrderWithoutItem.vue?vue&type=script&lang=js"
import style0 from "./OrderWithoutItem.vue?vue&type=style&index=0&id=6280328e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6280328e",
  null
  
)

export default component.exports